import axios from "axios";

const getCookie = (name) => {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

export const getObjetElemById = async (id, ent) => {
    let res = await axios.get(process.env.REACT_APP_API_URL + '/api/indicateur/objet/getObjetsElemPositionById/' + id,
        {headers: {"Authorization": `Bearer ${getCookie("current_apiToken")}`}}
    )
    return res.data
}

export const updateObjetElem = async (
    {
        idObjElem = '',
        typeObjet = '',
        config = {}
    }, ent) => {
    return await axios.post(process.env.REACT_APP_API_URL + '/api/indicateur/niveau/updateObjElem', {
            idObjElem: idObjElem,
            typeObjet: typeObjet,
            config: config
        },
        {headers: {"Authorization": `Bearer ${getCookie("current_apiToken")}`}}
    );
}

export const addObjetElem = async ({
                                       idNiveau = '',
                                       idObjElem = '',
                                       x = 0,
                                       y = 0,
                                       w = 0,
                                       h = 0,
                                       typeObjet = '',
                                       config = {}
                                   }, ent) => {
    let res = await axios.post(process.env.REACT_APP_API_URL + '/api/indicateur/niveau/addObjElem',
        {
            idNiveau: idNiveau,
            idObjElem: idObjElem,
            x: x,
            y: y,
            w: w,
            h: h,
            typeObjet: typeObjet,
            config: config
        },
        {headers: {"Authorization": `Bearer ${getCookie("current_apiToken")}`}}
    )
    return res;
}

export const loadNiveaux = async (idWidget, mode, ent) => {
    let res = await axios.get(process.env.REACT_APP_API_URL + '/api/indicateur/GetallNiveauByWidgetId/' + mode + '/' + idWidget,
        {headers: {"Authorization": `Bearer ${getCookie("current_apiToken")}`}}
    )
    return res.data;
}

// export const getAllSapsQuery = async (ent) => {
//     let res = await axios.get( process.env.REACT_APP_API_URL + '/api/getAllSaspQuery',
//         { headers: {"Authorization" : `Bearer ${getCookie("current_apiToken")}`} }
//     );
//     return res.data;
// }

export const getAllSapsQueryByTotemID = async (id, ent) => {
    let res = await axios.get(process.env.REACT_APP_API_URL + '/api/YDOS/getRequeteYdosByTotem/' + id);
    return res.data;
}

export const getAllListObjectif = async (id, ent) => {
    let res = await axios.get(process.env.REACT_APP_API_URL + '/api/getListObjectif/' + id,
        {headers: {"Authorization": `Bearer ${getCookie("current_apiToken")}`}}
    );
    return res.data;
}

export const getDayObjectif = async (id, year, month, day, ent) => {
    let res = await axios.get(process.env.REACT_APP_API_URL + '/api/getDayObjectifByID', {
        params: {
            id,
            year,
            month,
            day
        },
        headers: {"Authorization": `Bearer ${getCookie("current_apiToken")}`}
    });
    if (res.data.obj_objectif) {
        return res.data.obj_objectif;
    }
    return 'NC';
}

export const getYearObjectif = async (id, year, ent) => {
    let res = await axios.get(process.env.REACT_APP_API_URL + '/api/getYearObjectifByID', {
        params: {
            id,
            year
        }, headers: {"Authorization": `Bearer ${getCookie("current_apiToken")}`}
    });
    if (res.data) {
        return res.data;
    }
    return 'NC';
}

export const getAllObjectif = async (id, ent) => {
    let res = await axios.get(process.env.REACT_APP_API_URL + '/api/getAllObjectifByID', {
        params: {
            id
        }, headers: {"Authorization": `Bearer ${getCookie("current_apiToken")}`}
    });
    if (res.data) {
        return res.data;
    }
    return 'NC';
}
export const getAllInfoContext = async (ent) => {
    let res = await axios.get(process.env.REACT_APP_API_URL + '/api/indicateur/objet/getAllInfoContext',
        {headers: {"Authorization": `Bearer ${getCookie("current_apiToken")}`}}
    );
    return res.data;
}

export const getSaspQueryCOlumnNameById = async (id, ent) => {
    let res = await axios.get(process.env.REACT_APP_API_URL + '/api/requete/getColumns/' + id,
        {headers: {"Authorization": `Bearer ${getCookie("current_apiToken")}`}}
    )
    return res.data;
}

// export const getSaspQueryById = async (id) => {
//     let res = await axios.get(process.env.REACT_APP_API_URL + '/api/getSaspQueryById/'+ id)
//     return res.data
// }
